@if (isMatDialog) {
  <button
    mat-dialog-close
    aria-label="Close dialog"
    tabindex="-1"
    [class]="buttonClass"
    data-testid="dialog-close-button"
    data-close-button
  >
    <icon
      [size]="5"
      [name]="customizedCloseIcon() || 'close'"
      [currentColor]="type === 'plain' ? 'inherit' : 'primary'"
    >
    </icon>
  </button>
} @else {
  <button aria-label="Close" [class]="buttonClass" data-close-button (click)="handleClose()">
    <icon
      [size]="5"
      [name]="customizedCloseIcon() || 'close'"
      [currentColor]="type === 'plain' ? 'inherit' : 'primary'"
    >
    </icon>
  </button>
}
